import { type ChangeEvent, memo } from 'react';

import { Search as SearchIcon } from '@air/next-icons';
import { Input } from '@air/primitive-input';

export type InternalBrowseWorkspaceModalSearchProps = {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const InternalBrowseWorkspaceModalSearch = memo(({ onChange }: InternalBrowseWorkspaceModalSearchProps) => {
  return (
    <div className="relative w-full">
      <Input
        size="large"
        name="search"
        onChange={onChange}
        placeholder="Search workspace name or id"
        type="search"
        className="w-full pl-9"
      />
      <SearchIcon className="absolute top-1/2 left-3 size-4 -translate-y-1/2 text-grey-10" />
    </div>
  );
});

InternalBrowseWorkspaceModalSearch.displayName = 'InternalBrowseWorkspaceModalSearch';
